import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthContextProvider } from './context/AuthContext'
import { ModalProvider } from '../src/components/hooks/useModalContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthContextProvider>
      <ModalProvider>
        <App />
        </ModalProvider>
    </AuthContextProvider>
  </React.StrictMode>
);

